module.exports = __webpack_public_path__ + "static/media/2-1_Duplex_Gray_01.233f3fd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/2-1_Duplex_Gray_01.jpg
// module id = 1702
// module chunks = 0